export const MiscIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M6.6 0H5.4V3.6H6.6V0ZM6.6 8.4H5.4V12H6.6V8.4ZM12 5.4V6.6H8.4V5.4H12ZM3.6 6.6V5.4H0V6.6H3.6ZM7.8 3H9V4.2H7.8V3ZM10.2 1.8H9V3H10.2V1.8ZM4.2 3H3V4.2H4.2V3ZM1.8 1.8H3V3H1.8V1.8ZM7.8 9H9V10.2H10.2V9H9V7.8H7.8V9ZM3 9V7.8H4.2V9H3V10.2H1.8V9H3Z"
			fill="currentColor"
		/>
	</svg>
)
